import React, { useState, useEffect, useContext } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import { useUserAPI } from '../../components/useUserAPI';
import { ShoppingStart } from '../../components/ShoppingStart';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';
// import se_10 from '../../sound/s10_item_delete.mp3';

const motionConfig01 = {
	initial: {
		y: -30,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 30,
		opacity: 0,
	},
};
const motionConfig02 = {
	initial: {
		y: -20,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 20,
		opacity: 0,
	},
};
const modalBox_cover = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 0.55,
	},
	hidden: {
		opacity: 0,
	},
};

export const ItemDelete = (props) => {

// const [se08_se] = useSound(se_08);
// const [se10_delete,se10_delete_controls] = useSound(se_10);

// useEffect(() => {
// 	if(props.soundState !== "se10_delete" && props.soundState !== ""){
// 		se10_delete_controls.stop();
// 	}
// }, [props.soundState]);

// console.log(props.errNum);
const [delItemFlg, setDelItemFlg] = useState(false)

const delItem = (e) => {
	// e.stopPropagation();
	// props.setDelModal(false);

	document.querySelectorAll('.modalCloseBtn').forEach(function(element) {
		element.classList.add('is_nouse');
	});

	const bcode = props.delModal[0];
	const bnum = props.delModal[1];
	cancelAPI(ShoppingStartContext.data.token,bcode,bnum);

	// se08_se();
	props.setSoundState("se08_se");
	// setDelItemFlg(false);
	// props.setDelModal([]);
	// setDelItemFlg(true);
	// setTimeout(function(){
	// 	setDelItemFlg(false);
	// 	props.setDelModal([]);
	// }, 1200);
}

const closeModal = (e) => {
	e.stopPropagation();
	props.setDelModal([]);
	// se08_se();
	props.setSoundState("se08_se");

	//お買物API：画面遷移API（ホーム画面
	props.okaimonoAPI_didScreenTransition("home");
}

const { cancelAPI, data: cancelData, loading: cancelLoading, error: cancelError } = useUserAPI();
const ShoppingStartContext = useContext(ShoppingStart);

// const onSelectNum = () => {
// 	const bcode = props.delModal[0];
// 	const bnum = props.delModal[1];
// 	cancelAPI(ShoppingStartContext.data.token,bcode,bnum);
// }

useEffect(() => {
	if(cancelData){
		// console.log("あああ");
		if (cancelData.data) { //SUCCESS
			props.setShoppingData(cancelData);

			setDelItemFlg(true);
			setTimeout(function(){
				setDelItemFlg(false);
				props.setDelModal([]);

				//お買物API：画面遷移API（ホーム画面
				props.okaimonoAPI_didScreenTransition("home");
			}, 1000);
			// se10_delete_controls.stop();
			props.setSoundState("se10_delete");
			// se10_delete();
		}else{ //ERROR
			console.log(`【cancelAPI】 errorCode: ${cancelData.errorCode}`);
			console.log(`【cancelAPI】 errorMessage: ${cancelData.errorMessage}`);
			console.log(`【cancelAPI】 isSuccess: ${cancelData.isSuccess}`);

			setDelItemFlg(false);
			props.setDelModal([]);

			setTimeout(function(){
				if(cancelData.errorCode === "26"){
					//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
					props.setErrFlg(true);
					props.setErr([true,`${cancelData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
					// props.setErr([true,`${cancelData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				}else if(cancelData.errorCode === "27"){
					//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
					props.setErrFlg(true);
					props.setErr([true,`${cancelData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
					// props.setErr([true,`${cancelData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				}else{
					// props.setErrNum(`${cancelData.errorCode}`);
					// props.setShowModal(true);
					// props.setErrTxt(`${cancelData.errorMessage}`);
					props.setErrFlg(true);
					props.setErr([true,`${cancelData.errorCode}`,`${cancelData.errorMessage}`]);
				}
			}, 400);
		}
	}else{
		// console.log("えええ");
		// console.log("shoppingData: No Data");
	}
	if(cancelError){
		console.log("cancelError");
		console.log(cancelError);

		setDelItemFlg(false);
		props.setDelModal([]);

		setTimeout(function(){
			props.setErrFlg(true);
			props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
			// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
			// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		}, 400);
	}
	if(cancelLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [cancelData,cancelLoading,cancelError]);

return (
	<AnimatePresence>
	{props.delModal.length && (
	<>
	{
		(() => {
			if (props.delModal.length !== 0 && delItemFlg === false) {
			return(
				<section className="modalBox">
					<div className="modalBox_wrap">
						<div className="modalBox_in">
							<motion.div className="modalBox_info"
								initial={'initial'}
								animate={'animate'}
								exit={'hidden'}
								variants={motionConfig01}
								transition={{duration: 0.3, ease: 'easeInOut'}}
							>

							<p className="modalBox_tit">削除します<br/>
								よろしいですか？</p>

							<div className="modalBtn modalBtn01 modalCloseBtn" onClick={delItem}><span>OK</span></div>
							<div className="modalBtn modalBtn03 modalCloseBtn" onClick={closeModal}><span>キャンセル</span></div>


							</motion.div>
						</div>
						<motion.div className="modalBox_cover"
							initial={'initial'}
							animate={'animate'}
							exit={'hidden'}
							variants={modalBox_cover}
							transition={{duration: 0.35, ease: 'linear'}}
						></motion.div>
					</div>
				</section>
			)
			} else if (delItemFlg === true) {
			return(
				<section className="modalBox">
					<div className="modalBox_wrap">
				<motion.div className="changeNumComp"
					initial={'initial'}
					animate={'animate'}
					exit={'hidden'}
					variants={motionConfig02}
					transition={{duration: 0.5, delay: 0, ease: 'easeInOut'}}
				>
					<figure className="changeNumComp_img">
						<img src="/images/icn_delete.svg" alt="" width="48" height="48"/>
					</figure>
					<p className="changeNum_tit">削除しました</p>
				</motion.div>
					</div>
				</section>
			)
			} else {
			// return (

			// )
			}
		})()
	}
		{/* {props.delModal ? ( // delModalがtrueだったらModal表示
			<section className="modalBox">
				<div className="modalBox_wrap">
					<div className="modalBox_in">
						<motion.div className="modalBox_info"
							initial={'initial'}
							animate={'animate'}
							exit={'hidden'}
							variants={motionConfig}
							transition={{duration: 0.3, ease: 'easeInOut'}}
						>

						<p className="modalBox_tit">削除します<br/>
							よろしいですか？</p>

						<button className="modalBtn modalBtn01" onClick={delItem}><span>OK</span></button>
						<button className="modalBtn modalBtn03" onClick={closeModal}><span>キャンセル</span></button>


						</motion.div>
					</div>
				</div>
			</section>

		) : ( // showModalがfalseの場合はModal非表示
			<>
<div className="changeNumComp">
	<figure className="changeNumComp_img">
		<img src="/images/icn_delete.svg" alt="" width="48" height="48"/>
	</figure>
	<p className="changeNum_tit">削除しました</p>
</div>
			</>
		)} */}
	</>
	)}
	</AnimatePresence>
)

}
